/* eslint-disable no-mixed-spaces-and-tabs */
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { getUsersRolesListRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import {
	GET_USERS_ROLES_LIST,
	setIsUsersRolesListLoadingAction,
	setPaginationAction,
	setUsersRolesListAction,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getUsersRolesListSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsUsersRolesListLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getUsersRolesListRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setUsersRolesListAction(
					data?.map(role => ({
						...role,
						...(role.disabled
							? {}
							: {
									link: `?${searchQuery ? `${searchQuery}&` : ''}modal=user_role&id=${role.id}`,
							  }),
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsUsersRolesListLoadingAction(false));
	}
}

export default function* usersRolesContainerSaga() {
	yield takeEvery(GET_USERS_ROLES_LIST, getUsersRolesListSaga);
}
